import { useQuery } from 'react-query';

import { AFFILIATE_SETTINGS_KEY, getAffiliateSettings } from '@utils/backend-api/settings';

export default function useAffiliateSettings() {
  const { data: affiliateSettings, isLoading: isLoadingAffiliateSettings } = useQuery(
    AFFILIATE_SETTINGS_KEY,
    getAffiliateSettings
  );

  return { affiliateSettings, isLoadingAffiliateSettings };
}
